import { sitemap, category, article } from "./sitemap_template";

export const sitemappage = async (client, navdata) => {

    //Using setTimout to detach from main thread
    setTimeout(() => {
      const allArticlesPromises = traverseSite(navdata[0]);
      Promise.all(allArticlesPromises).then( _ =>{
        console.log("Done:");
        document.getElementById("maincontent").innerHTML = sitemap({content: buildSiteMap(navdata[0]) });
      });
    },0)
};

const traverseSite = (navs) => {
  let allArticlesPromises = [];
  navs.forEach( nav => {
    const articlesPromise = getArticlesForCategory(nav.categoryId)
      .then((allArticles) => {
        nav._articles = allArticles;
      })
      .catch((error) => {
        console.log("Error:", error);
      });

    allArticlesPromises.push(articlesPromise);

    if (nav.children?.length > 0) {
      const childArticlesPromise = traverseSite(nav.children);
      allArticlesPromises = allArticlesPromises.concat(childArticlesPromise);
    }
  });
  return allArticlesPromises;
};

const buildSiteMap = (navs, level = 0) => {
  level++;
  let htmlString =``;
  navs.forEach( nav => {
    
    htmlString+=category({
          item: nav,
          level: level,
        })
    nav._articles.forEach( a => {
      let shouldDisplay = a.contentTypeGuid != "17c15981-758d-4d09-a7ee-b2d47d2af6f0"; //forsidebilde
      if(shouldDisplay) {htmlString += article({
          item: a,
          level: level,
        })}
    });
    if (nav.children?.length > 0) {
      htmlString += buildSiteMap(nav.children, level);
    }
  });
  return htmlString;
};

const getArticlesForCategory = (category) => {
  let config = JSON.parse(sessionStorage.getItem("config"));
  let senddata = JSON.stringify({
    categoryId: category,
    subscriptionId: config.clientId,
  });

  return fetch(
    window.apiUrl + "/api/PublicContentApi/getbycategoryidasstring",
    {
      method: "POST",
      headers: { "Content-Type": "application/json-patch+json" },
      body: senddata,
    }
  )
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};
